import { useState } from 'react';
import { Character } from '@/network/RestApi';
import { useUIStore } from '@/state/uiStore';
import { ui } from './theme';
import { CloseButton } from './CloseButton';

const CLASSES: Array<{ id: 'warrior' | 'wizard' | 'archer'; label: string; desc: string; color: string; portrait: string }> = [
  { id: 'warrior', label: 'Dark Knight', desc: 'Tank cận chiến · Máu trâu · AoE', color: '#ff5a4a', portrait: '/assets/ui/charselect/portrait_warrior.png' },
  { id: 'wizard',  label: 'Dark Wizard', desc: 'Phép thuật AoE · Sát thương cao', color: '#6cb9ff', portrait: '/assets/ui/charselect/portrait_wizard.png' },
  { id: 'archer',  label: 'Elf Archer',  desc: 'Tầm xa · Crit cao · Hỗ trợ',     color: '#6dd97a', portrait: '/assets/ui/charselect/portrait_archer.png' },
];

export function CreateCharacterModal() {
  const close = () => useUIStore.getState().set('menu', false);
  const showToast = useUIStore((s) => s.showToast);
  const [name, setName] = useState('');
  const [klass, setK] = useState<typeof CLASSES[number]['id']>('warrior');
  const [busy, setBusy] = useState(false);
  const sel = CLASSES.find((c) => c.id === klass)!;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await Character.create({ name, class: klass });
      showToast(`Đã tạo ${name}`);
      close();
      location.reload();
    } catch (err) { showToast((err as Error).message, 'error'); }
    finally { setBusy(false); }
  };

  return (
    <div
      data-block-game-input="true"
      onPointerDown={(e) => e.stopPropagation()}
      onPointerUp={(e) => e.stopPropagation()}
      onClick={(e) => { if (e.target === e.currentTarget) close(); }}
      style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, pointerEvents: 'auto' }}>
      <form onSubmit={submit}
        data-block-game-input="true"
        onPointerDown={(e) => e.stopPropagation()}
        onPointerUp={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        style={{ width: 760, ...ui.panel, display: 'grid', gridTemplateColumns: '280px 1fr', gap: 18 }}>
        {/* Portrait preview */}
        <div style={{
          position: 'relative',
          height: 420,
          borderRadius: 6,
          background: `radial-gradient(ellipse at center, ${sel.color}22 0%, #0c1426 70%)`,
          border: `2px solid ${sel.color}`,
          boxShadow: `inset 0 0 32px ${sel.color}33, 0 0 18px ${sel.color}55`,
          overflow: 'hidden',
        }}>
          <img src={sel.portrait} alt={sel.label}
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain', filter: `drop-shadow(0 8px 16px ${sel.color}88)` }} />
          <div style={{
            position: 'absolute', bottom: 8, left: 0, right: 0, textAlign: 'center',
            color: '#ffe7a3', fontFamily: '"Cinzel", serif', fontSize: 22, letterSpacing: 2,
            textShadow: '0 2px 6px #000',
          }}>{sel.label.toUpperCase()}</div>
        </div>

        {/* Right column */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <strong style={{ fontFamily: '"Cinzel", serif', fontSize: 22, color: '#ffe7a3', letterSpacing: 1 }}>TẠO ANH HÙNG</strong>
            <CloseButton onClick={close} />
          </div>

          <label style={{ fontSize: 12, color: '#cdb175', marginBottom: 4 }}>TÊN NHÂN VẬT (4-16 ký tự)</label>
          <input style={ui.input} placeholder="VD: HacAm, AnhHung..." value={name}
            onChange={(e) => setName(e.target.value)} required minLength={4} maxLength={16} />

          <label style={{ fontSize: 12, color: '#cdb175', margin: '14px 0 6px' }}>CHỌN LỚP NHÂN VẬT</label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {CLASSES.map((c) => {
              const active = klass === c.id;
              return (
                <button key={c.id} type="button" onClick={() => setK(c.id)}
                  style={{
                    padding: '10px 12px',
                    borderRadius: 4,
                    background: active ? `linear-gradient(90deg, ${c.color}33, transparent)` : 'rgba(11,18,32,0.6)',
                    border: `2px solid ${active ? c.color : '#324a5e'}`,
                    color: '#fff', cursor: 'pointer', textAlign: 'left',
                    transition: 'all .15s',
                    boxShadow: active ? `0 0 12px ${c.color}66` : 'none',
                  }}>
                  <div style={{ fontWeight: 700, fontFamily: '"Cinzel", serif', color: active ? c.color : '#ffe7a3', letterSpacing: 1 }}>{c.label}</div>
                  <div style={{ fontSize: 12, opacity: 0.85, color: '#cdb175' }}>{c.desc}</div>
                </button>
              );
            })}
          </div>

          <button type="submit" disabled={busy}
            style={{ ...ui.primaryBtn, marginTop: 18, width: '100%', height: 44, fontSize: 16, letterSpacing: 1.5 }}>
            {busy ? '...' : '⚔  KHỞI HÀNH'}
          </button>
        </div>
      </form>
    </div>
  );
}

